import { withI18n } from 'react-i18next';
import InvoiceToolbar from './InvoiceToolbar';

export const pureComponent = InvoiceToolbar;
export default withI18n()(InvoiceToolbar);
